import React, { useEffect } from 'react';
import { IoMdCloseCircle } from "react-icons/io";
import bangalore from "../assets/Bangalore/bangalore.jpg"
const Modal = () => {
  useEffect(() => {
    const bootstrap = require('bootstrap/dist/js/bootstrap.bundle.min.js');
    const modalElement = document.getElementById('autoModal');
    const modal = new bootstrap.Modal(modalElement);
    modal.show();
  }, []);

  return (
    <div
      className="modal fade"
      id="autoModal"
      tabIndex="-1"
      aria-labelledby="autoModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered modal-animate relative">
        <div className="modal-content modal-bg-c">
          <div className="modal-body custom-padding-modal d-flex flex-column">
            <div className="d-flex justify-content-between align-items-center mb-0">
<IoMdCloseCircle   type="button"
  className="text-white fs-2 text-end modal-btn-absolute"
  data-bs-dismiss="modal"
  aria-label="Close"/>

            </div>
            <img src = {bangalore} className="img-fluid mb-3 event-border-radius" alt = "Bangalore Event" title = "Bangalore Event"/>
            <a
  href="https://capitalconnect.bizdateup.com/"
  target="_blank"
  rel="noopener noreferrer"
  className="btn btn-light text-dark fw-bold text-uppercase " 
>
  Click Here For More Details
</a>

          </div>

        </div>
      </div>
    </div>
  );
};

export default Modal;
